import {createFileRoute} from '@tanstack/react-router';
import {companyAdminGranted, grantUser} from '@/practitioner/routing/utils/beforeLoadUtils';

import UpdatePaymentMethod from '@/practitioner/views/company/UpdatePaymentMethod';

export const Route = createFileRoute(
  '/(practitioner)/company/subscription-plan/update-payment-method'
)({
  component: UpdatePaymentMethod,
  beforeLoad: grantUser(companyAdminGranted)
});
